import Vue from 'vue'
import VueNumberInput from '@chenfengyuan/vue-number-input'

Vue.use(VueNumberInput)
